import { httpPost, httpPatch, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { IFieldSetField } from '~/types/fieldSet/models'

const apiEntityPath = '/api/fieldsetfields'

export async function createFieldSetField(entity: IFieldSetField) {
  const callingMn = createFieldSetField.name
  const apiPath = `${apiEntityPath}`
  return httpPost({ callingMn, apiPath, entity })
}

export async function updateFieldSetField(
  updateData: Partial<IFieldSetField>,
  id: TEntityId
) {
  const callingMn = updateFieldSetField.name
  const apiPath = `${apiEntityPath}/${id}`
  return httpPatchMerge({
    callingMn,
    apiPath,
    entityData: updateData,
  })
}

export async function updateFieldSetFieldSeqNums(
  updateData: Partial<IFieldSetField>[]
) {
  const callingMn = updateFieldSetFieldSeqNums.name
  const apiPath = `${apiEntityPath}`
  return httpPatch({
    callingMn,
    apiPath,
    entityData: updateData,
  })
}

export async function deleteFieldSetField(entityData: IFieldSetField) {
  const callingMn = deleteFieldSetField.name
  const apiPath = `${apiEntityPath}`
  return httpDelete({ callingMn, apiPath, entityData })
}
